import PageWrapper from 'components/utils/PageWrapper';
import Jobs from 'pages/Jobs';

export const jobsRoutes = {
    path: '/jobs',
    element: (
        <PageWrapper titleId="jobs_title">
            <Jobs />
        </PageWrapper>
    ),
};
